import { useEffect, useRef } from "react";

/**
 * Polling sicuro: intervallo configurabile (default 10s), nessuna richiesta
 * sovrapposta (guard in-flight), sospeso quando la scheda non è visibile e
 * aggiornamento immediato al ritorno in primo piano. Non esegue il primo fetch
 * (lo fa la pagina): aggiorna solo i dati server senza toccare bozze/form.
 */
export function usePolling(fn, { interval = 10000, enabled = true } = {}) {
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(() => {
    if (!enabled) return undefined;
    let stopped = false;
    let inFlight = false;

    const run = async () => {
      if (stopped || inFlight || document.hidden) return;
      inFlight = true;
      try { await fnRef.current(); } catch { /* noop */ }
      inFlight = false;
    };

    const timer = setInterval(run, interval);
    const onVisible = () => { if (!document.hidden) run(); };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      stopped = true;
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [interval, enabled]);
}
